import { combineReducers } from '@reduxjs/toolkit';
import { photoFilterSlice } from './photo-filter/photo-filter.slice';
import { photoFilterTemplateSlice } from './photo-filter/photo-filter-template.slice';
import { memberSlice } from './member/member.slice';
import { photoAlbumSlice } from './photo-album/photo-album.slice';
import { advertisementSlice } from './advertisement/advertisement.slice';
import { advertisementPlaylistSlice } from './advertisement/advertisement-playlist.slice';
import { currencySlice } from './currency/currency.slice';

const settingReducer = combineReducers({
  photoFilter: photoFilterSlice.reducer,
  photoFilterTemplate: photoFilterTemplateSlice.reducer,
  member: memberSlice.reducer,
  photoAlbum: photoAlbumSlice.reducer,
  advertisement: advertisementSlice.reducer,
  advertisementPlaylist: advertisementPlaylistSlice.reducer,
  currency: currencySlice.reducer,
});

export default settingReducer;
